import { CLEAR_RESOURCES } from 'store/resources/types'
import { CLEAR_STATUS } from 'store/ui/types'
import * as types from './types'

const initialState = {
  list: null,
}

export default function addressAccess(state = initialState, { type, payload }) {
  switch (type) {
    case types.GET_ADDRESS_ACCESS_SUCCESS:
      return {
        ...state,
        list: payload,
        error: null,
      }
    case types.GET_ADDRESS_ACCESS_ERROR:
      return { ...state, error: payload }
    case CLEAR_RESOURCES:
      return initialState
    case CLEAR_STATUS:
      return { ...state, error: null, msg: null }
    default:
      return state
  }
}
